import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { SystemSettingsStore } from '../../core/services/system-settings.store';
import { getLogoHeight } from '../../core/services/theme.model';

@Component({
  selector: 'app-logo',
  imports: [],
  host: { class: 'block min-w-0 max-w-full' },
  template: `
    @if (systemSettingsStore.branding()?.light || systemSettingsStore.branding()?.dark) {
      <img
        class="w-auto max-w-full shrink-0 object-contain only-light-theme"
        data-cy="logo"
        alt="logo"
        [style.height.px]="logoHeight()"
        [src]="systemSettingsStore.branding()?.light?.logo?.blobUrl" />
      <img
        class="w-auto max-w-full shrink-0 object-contain only-dark-theme"
        data-cy="logo"
        alt="logo"
        [style.height.px]="logoHeight()"
        [src]="systemSettingsStore.branding()?.dark?.logo?.blobUrl" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
})
export class LogoComponent {
  readonly systemSettingsStore = inject(SystemSettingsStore);
  readonly logoHeight = computed(() => getLogoHeight(this.systemSettingsStore.branding()));
}
